import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import Modal, { ModalSize } from '../Modal/Modal';
import './ServiceWallet.css';

interface CreditsDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  icon?: IconDefinition;
  size?: ModalSize;
  children: React.ReactNode;
}

const CreditsDialog: React.FC<CreditsDialogProps> = ({
  open,
  onClose,
  title,
  subtitle,
  icon,
  size = 'lg',
  children,
}) => (
  <Modal open={open} onClose={onClose} title={title} icon={icon} size={size}>
    {subtitle && <p className="sw-dialog-subtitle">{subtitle}</p>}
    {children}
  </Modal>
);

export default CreditsDialog;
